// newDesign is set to true in /v5
export const getAdTilePositions = (
  adProvider,
  windowWidth,
  newDesign = false
) => {
  const layoutType = newDesign
    ? getTileLayoutTypeV5(windowWidth)
    : getTileLayoutType(windowWidth)
  const adProviderObj = positions[adProvider]
  const adTilePositions = adProviderObj[layoutType]
  return adTilePositions
}

const positions = {
  Ads_V5: {
    'Layout 1': {
      firstRowAdTilePosition: 4,
      secondRowAdTilePosition: 11,
      thirdRowAdTilePosition: 23,
      adTilePositionIncrement: 10,
      belowFoldAdTilePosition: 17,
    },
    'Layout 2': {
      firstRowAdTilePosition: 3,
      secondRowAdTilePosition: 8,
      thirdRowAdTilePosition: 18,
      adTilePositionIncrement: 8,
      belowFoldAdTilePosition: 13,
    },
    'Layout 3': {
      firstRowAdTilePosition: 2,
      secondRowAdTilePosition: 8,
      thirdRowAdTilePosition: 17,
      adTilePositionIncrement: 8,
      belowFoldAdTilePosition: 9,
    },
    'Layout 4': {
      firstRowAdTilePosition: 1,
      secondRowAdTilePosition: 3,
      thirdRowAdTilePosition: 16,
      adTilePositionIncrement: 8,
      belowFoldAdTilePosition: 6,
    },
    'Layout 5': {
      firstRowAdTilePosition: 3,
      secondRowAdTilePosition: 8,
      thirdRowAdTilePosition: 18,
      adTilePositionIncrement: 8,
      belowFoldAdTilePosition: 2,
    },
  },
}

const getTileLayoutType = (windowWidth) => {
  if (windowWidth >= 1920) {
    return 'Layout 1'
  } else if (windowWidth > 1440) {
    return 'Layout 2'
  } else if (windowWidth > 992 && windowWidth <= 1440) {
    return 'Layout 3'
  } else if (windowWidth > 630 && windowWidth <= 992) {
    return 'Layout 4'
  } else if (windowWidth <= 630) {
    return 'Layout 5'
  }
}

const getTileLayoutTypeV5 = (windowWidth) => {
  if (windowWidth >= 1920) {
    return 'Layout 1'
  } else if (windowWidth > 1350) {
    return 'Layout 2'
  } else if (windowWidth > 980) {
    return 'Layout 3'
  } else if (windowWidth > 630) {
    return 'Layout 4'
  } else if (windowWidth <= 630) {
    return 'Layout 5'
  }
}
